<template lang="pug">
transition(
  name="fa"
  )
  .qr-page
    .card
      .card-circle
      img.qr-code(src="~assets/ui/qroffical.jpg")
      img.copy(src="~assets/ui/menu/qrcopy-w.png")
      svg.close(@click="closeQRPage")
        use(xlink:href="#icon-close")


</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power2, Circ} from 'gsap'
import IconClose from 'src/components/vca/widgets/IconClose'
//import Component from '@/components/Component'

export default {
  name: "QRPage",
  props: {
    prop: {
      default: false,
      required: false
    }
  },
  components: {
    IconClose
  },
  data() {
    return {
      progress: 0
    }
  },
  computed:{
    p(){
      return this.progress*141
    }
  },
  methods: {
    ...mapMutations('app', ['closeQRPage']),
    init() {},
    // animateIn(cb) {
    //
    //   let tl = new TimelineMax({ onComplete: cb})
    //   this.tl = tl
    //   let sw = window.innerWidth
    //   let sh = window.innerHeight
    //   let R = Math.sqrt(Math.pow(sw, 2)+ Math.pow(sh, 2))
    //   let xoff = (R - sw)/2
    //   let yoff = (R - sh)/2
    //
    //   tl.add('start')
    //     .set(
    //       this.$refs.bg,
    //       {
    //         width: R,
    //         height: R,
    //         x: -xoff,
    //         y: -yoff,
    //       }
    //     )
    //     .to(
    //       this,
    //       1,
    //       {
    //         progress: 1,
    //         ease: Sine.easeIn
    //       },
    //       `start+=0.5`
    //     )
    //
    // },

    // enter(el, done){
    //   this.animateIn(done)
    // },
    // leave(el, done){
    //   //this.animateOut(done)
    //   done()
    // },
    svgclick(e){
      console.log(e)
      if (e.target.parentElement.id === 'close'){
        let tl = new TimelineMax({ onComplete: () => {
          this.closeQRPage()
          } })
        this.tl = tl

        tl.add('start')
          .to(
            this,
            1,
            {
              progress: 0,
              ease: Power2.easeOut
            },
            `start+=0`
          )
      }

    }
  },
  mounted() {
    this.init()
    //this.animate()
    //this.animateIn()
  },
  beforeDestroy(){

  },
  watch: {

  }
}
</script>


<style lang="sass">
  @import "src/styles/common.sass"
  .qr-page
    +full()
    display: flex
    justify-content: center
    align-items: center
    pointer-events: all

    .card

      width: 100%

      position: relative
      display: flex
      align-items: center
      justify-content: center
      flex-direction: column
      .card-circle
        padding-top: 120%
        width: 120%
        height: auto
        border-radius: 50%
        position: absolute
        background: $cl-blue
        transform-origin: center
        //transform: scale(1.2)
        z-index: 10
        //transition-duration: 0.7s
        //transition-timing-function: ease-out

      .qr-code
        margin-top: 1rem
        pointer-events: all
        display: block
        width: 45%
        z-index: 11
        //background: #ffd81b
      .copy
        //background: #3a602e
        width: 1.8rem
        z-index: 11
        text-align: center
        margin-top: 0.15rem
        display: block
      .close
        //background: #e15125
        display: block
        z-index: 11
        line-height: 0
        width: 0.5rem
        height: 0.5rem
        margin-top: 0.2rem




  //.qr-enter, .qr-leave-to
    .card-circle
      transform: scale(0.2)
    //.line
      font-size: $fs-s
      color: $cl-blue
  .fa-enter-active
    transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1)
    .card-circle
      transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1)
    .qr-code
      transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0.1s
    .copy
      transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0.2s
    .close
      transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0.3s
  .fa-leave-active
    transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0.2s
    .card-circle
      transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0.2s
    .qr-code
      transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0.1s
    .copy
      transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1)
    .close
      transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1)
  .fa-enter, .fa-leave-to
    //opacity: 0.2
    .qr-code
      opacity: 0.2
      transform: scale(0)
    .card-circle
      transform: scale(0)
    .copy
      opacity: 0
      transform: scale(0) translateY(-100%)
    .close
      transform: scale(0) translateY(-100%)



</style>